export enum OrderByValue {
    Default = 'Default',
    Bpm = 'Bpm',
    Instrument = 'Instrument',
    Key = 'Key',
    Name = 'Name',
    Pack = 'Pack',
    TextSearch = 'TextSearch',
    Recommandation = 'Recommandation',
    Popularity = 'Popularity',
    Recent = 'Recent',
    Trending = 'Trending',
}

export interface Order {
    key: OrderByValue;
    ascending: boolean;
}
